import * as React from 'react';
const SvgMinus = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
        <rect y={7} width={16} height={2} rx={1} fill="currentColor" />
    </svg>
);
export default SvgMinus;
